var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-teams-wrapper"},[_c('b-spinner',{staticClass:"spinner"}),_c('span',[_vm._v("Загрузка команд")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }